import axios from "axios";

const serverURL = process.env.REACT_APP_API_URL;
const serverLoginURL = process.env.REACT_APP_API_LOGIN_URL
const serverRsvpURL = process.env.REACT_APP_API_RSVP_URL

const axiosConfig={withCredentials:true};
const axiosFormDataConfig={withCredentials:true, headers: {"Content-Type": "multipart/form-data"}};

// const userId = JSON.parse(localStorage.getItem("user"));
// const eventid = JSON.parse(localStorage.getItem("eventId"));

// ? AUTHENTICATION
export const userLogin = (credentials) => {
  return axios.post(`${serverLoginURL}/signin`, credentials, axiosConfig);
};

export const userSignup = (credentials) => {
  return axios.post(`${serverLoginURL}/signup`, credentials, axiosConfig);
};
export const rspvPostFormApi = (data) => {
  return axios.post(`${serverRsvpURL}/responses`, data, axiosConfig);
};
export const rspvPostNameMatch = (data) => {
  return axios.post(`${serverRsvpURL}/nameMatch`, data, axiosConfig);
};

export const rspvAdditionalGuestApi = (data) => {
  return axios.post(`${serverRsvpURL}/additionalguest`, data, axiosConfig);
};

export const apiGetFontList = () => {
  return axios.get(`${serverRsvpURL}/fontList`, axiosConfig);
}

export const changePassword = (data) => {
  return axios.post(`${serverURL}/user/changePassword`, data, axiosConfig);
};
export const postLogout = (data) => {
  return axios.post(`${serverURL}/user/logout`, data, axiosConfig);
};
export const logError = (data) => {
  return axios.post(`${serverLoginURL}/logError`, data, axiosConfig);
};

export const forgotPassword = (credentials) => {
  return axios.post(`${serverLoginURL}/forgotPassword`, credentials, axiosConfig);
};
export const resetPassword = (token, credentials) => {
  return axios.put(`${serverLoginURL}/resetPassword/${token}`, credentials, axiosConfig);
};
export const userOtpLogin = (credentials) => {
  return axios.post(`${serverURL}/user/otpsignin`, credentials, axiosConfig);
};

export const postUploadFullPDF = (data) => {
  const id = JSON.parse(localStorage.getItem("user"));
  const eventID = JSON.parse(localStorage.getItem("eventId"));
  return axios.post(`${serverURL}/pdf/fullUpload/user/${id}/event/${eventID}`, data, axiosConfig);
}

export const getPreviewURL = (eventId, guestId) => {
  const id = JSON.parse(localStorage.getItem("user"));
  return `${serverURL}/pdf/preview/user/${id}/event/${eventId}/guest/${guestId}?c=`+Math.round(Math.random()*1e8);
}

export const apiGetPDFData = () => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.get(`${serverURL}/pdf/data/user/${id}`, axiosConfig);
}
export const apiPostPDFData = (data) => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.post(`${serverURL}/pdf/data/user/${id}`, data, axiosConfig);
}
export const postSendTestEmail = (data) => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.post(`${serverURL}/pdf/sendTest/user/${id}`, data, axiosConfig);
}
export const postSendLiveEmail = (data) => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.post(`${serverURL}/pdf/sendLive/user/${id}`, data, axiosConfig);
}
export const postSendQRCodeEmail = (data) => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.post(`${serverURL}/pdf/sendQR/user/${id}`, data, axiosConfig);
}

export const UploadTemplateImage = (data) => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.post(`${serverURL}/pdf/image/user/${id}`, data, axiosConfig);
};
export const getTemplateImage = () => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.get(`${serverURL}/pdf/image/user/${id}`, axiosConfig);
};

export const getGuests = () => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.get(`${serverURL}/pdf/guests/user/${id}`, axiosConfig);
}

// ? EVENT
export const getEventById = () => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.get(`${serverURL}/userevents/${id}`, axiosConfig);
};

export const getPreviewRsvpCode = () => {
  const event_id = JSON.parse(localStorage.getItem("eventId"));
  return axios.get(`${serverURL}/events/getPreviewRsvpCode/event/${event_id}`, axiosConfig);
};

// * This api handle both post and put.
export const updateUserEvents = (event) => {
  return axios.put(`${serverURL}/userevents`, event, axiosConfig);
};

export const postRsvpStyle = (data) => {
  return axios.post(`${serverURL}/events/style`,data, axiosConfig);
};

export const eventAllDetails = () => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.post(`${serverURL}/userevents/${id}`,{}, axiosConfig);
};

export const createCeremonies = (ceremony) => {
  return axios.post(`${serverURL}/ceremony`, ceremony, axiosConfig);
};

export const getCeremoniesByEventIds = () => {
  const event_id = JSON.parse(localStorage.getItem("eventId"));
  return axios.get(`${serverURL}/ceremony/${event_id}`, axiosConfig);
};

export const getEventByUserId = () => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.get(`${serverURL}/events/${id}`, axiosConfig);
};

// ? FOOD
// * This api handle both post and put.
export const updateUserFoods = (food) => {
  return axios.put(`${serverURL}/userfoods`, food, axiosConfig);
};

export const getInvitationsByUserId = () => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.get(`${serverURL}/invitations/user/${id}`, axiosConfig);
};
export const getInvitationCodesByUserId = () => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.get(`${serverURL}/invitations/codes/user/${id}`, axiosConfig);
};

export const updateInvitation = (data) => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.post(`${serverURL}/invitations/update/user/${id}`, data, axiosConfig);
};
export const updateGroupInvitation = (data) => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.post(`${serverURL}/invitations/update/group/user/${id}`, data, axiosConfig);
};

export const postNamedGogInvite = (data) => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.post(`${serverURL}/invitations/update/named/user/${id}`, data, axiosConfig);
};


// * GROUPS
// ? GET GROUP BY USERID
export const getGroupByUserId = () => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.get(`${serverURL}/groups/${id}`, axiosConfig);
};
export const deleteGroupByUserId = (groupId) => {
  return axios.delete(`${serverURL}/groups/${groupId}`, axiosConfig);
};

export const addGroup = (data) => {
  return axios.post(`${serverURL}/groups`, data, axiosConfig);
};
export const renameGroup = (data) => {
  return axios.post(`${serverURL}/groups/${data.group_id}`, data, axiosConfig);
};

// ? ADD GUEST IN A GROUP
export const getGuestForGroup = (groupName) => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.get(`${serverURL}/guest/users/${id}/group/${groupName}`, axiosConfig);
};
export const getAllGuestForUser = () => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.get(`${serverURL}/guest/getallguest/${id}`, axiosConfig);
};
export const addGuestInAGroup = (data) => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.post(`${serverURL}/guest/${id}`, data, axiosConfig);
};
export const deleteGuestInAGroup = (guestId) => {
  return axios.delete(`${serverURL}/guest/${guestId}`, axiosConfig);
};
export const postMoveToAGroup = (data) => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.post(`${serverURL}/guest/${id}/moveToGroup`, data, axiosConfig);
};


export const postNamedGuestOfGuest = (data) => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.post(`${serverURL}/guest/namedEdit/user/${id}`, data, axiosConfig);
}
export const postDeleteNamedGuestOfGuest = (data) => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.post(`${serverURL}/guest/namedDelete/user/${id}`, data, axiosConfig);
}

// * UPDATE GUEST
export const updateGuest = (data) => {
  return axios.put(`${serverURL}/guest/${data.guestId}`, data.mappedData, axiosConfig);
};

// ? SCREENSHOT UPLOAD
export const sendScreenShotsWedding = (images) => {
  const id = JSON.parse(localStorage.getItem("user"));
  const eventId = JSON.parse(localStorage.getItem("eventId"));

  return axios.post(
    `${serverURL}/pdf/wedding/users/${id}/event/${eventId}`,
    images,
    axiosFormDataConfig
  );
};

export const weAreEngaged = (images) => {
  const id = JSON.parse(localStorage.getItem("user"));
  const eventId = JSON.parse(localStorage.getItem("eventId"));

  return axios.post(
    `${serverURL}/pdf/WeAreEngaged/users/${id}/event/${eventId}`,
    images,
    axiosFormDataConfig
  );
};
export const ThankYou = (images) => {
  const id = JSON.parse(localStorage.getItem("user"));
  const eventId = JSON.parse(localStorage.getItem("eventId"));

  return axios.post(
    `${serverURL}/pdf/thankyou/users/${id}/event/${eventId}`,
    images,
    axiosFormDataConfig
  );
};
// '/savethedate/users/:user_id/',
export const sendSaveTheDate = (images) => {
  const id = JSON.parse(localStorage.getItem("user"));
  const eventId = JSON.parse(localStorage.getItem("eventId"));

  return axios.post(
    `${serverURL}/pdf/savethedate/users/${id}/event/${eventId}`,
    images,
    axiosFormDataConfig
  );
};

export const weddingTestMail = (images) => {
  return axios.post(`${serverURL}/pdf/WeddingTestMail`, images, axiosFormDataConfig);
};
export const weEngagedTestMail = (images) => {
  return axios.post(`${serverURL}/pdf/WeAreEngagedTestMail`, images, axiosFormDataConfig);
};
export const saveTheDateTestMail = (images) => {
  return axios.post(`${serverURL}/pdf/saveTheDateTestMail`, images, axiosFormDataConfig);
};
export const thankYouTestMail = (images) => {
  return axios.post(`${serverURL}/pdf/thankyouTestMail`, images, axiosFormDataConfig);
};

// ? REVP FORM
export const rspvFormApi = () => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.get(`${serverURL}/rsvp/responses/${id}`,axiosConfig);
};

// ? Get Groups in the ceremonies

export const getGroupsInceremony = (data) => {
  return axios.post(`${serverURL}/ceremony/groups`, data,axiosConfig);
};

// ? GET ALL CEREMONIES
export const getAllCeremony = () => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.get(`${serverURL}/ceremony/user/${id}`,axiosConfig);
};

export const addSelectedCeremonies = (data) => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.put(`${serverURL}/ceremony/user/${id}`, data,axiosConfig);
};

// ? GET ALL DRINKS

export const getAllDrinks = () => {
  return axios.get(`${serverURL}/drinks`,axiosConfig);
};

export const getAllFoods = () => {
  return axios.get(`${serverURL}/foods`,axiosConfig);
};

// GET USER GROUPS BY USERID

export const getUserGroupsFromUserId = () => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.get(`${serverURL}/ceremony/usergroup/${id}`,axiosConfig);
};

// ADD GROUPS IN THE CEREMONIES

export const addGroupsInACeremonies = (data) => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.post(`${serverURL}/ceremony/groups/${id}`, data,axiosConfig);
};

// ? DASHBOARD
// * ALLEGIES
export const getAllergies = () => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.get(`${serverURL}/dashboard/getAllergies/${id}`,axiosConfig);
};

// *getTotalPersonalAssistance
export const getTotalPersonalAssistance = () => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.get(`${serverURL}/dashboard/getTotalPersonalAssistance/${id}`,axiosConfig);
};

// */dashboard/getTotalMUA/118
export const getMUA = () => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.get(`${serverURL}/dashboard/getTotalMUA/${id}`,axiosConfig);
};

// *getTotalDhotiAssistance
export const getDhotiAssistance = () => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.get(`${serverURL}/dashboard/getTotalDhotiAssistance/${id}`,axiosConfig);
};

export const getTurbanAssistance = () => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.get(`${serverURL}/dashboard/getTotalTurbanAssistance/${id}`,axiosConfig);
};

export const getSareeAssistance = () => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.get(`${serverURL}/dashboard/getTotalSareeAssistance/${id}`,axiosConfig);
};

export const getGuestListWithMembers = () => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.get(`${serverURL}/dashboard/getGuestListWithMembers/${id}`,axiosConfig);
};

export const getFoodCount = () => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.get(`${serverURL}/dashboard/getFoodCountWithTextResponse/user/${id}`,axiosConfig);
};
export const getCeremony = () => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.get(`${serverURL}/dashboard/getTotalCeremonyByText/user/${id}`,axiosConfig);
};

export const getFilterCeremony = (ceremony_id) => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.get(`${serverURL}/dashboard/getGuestListByCeremony/user/${id}/ceremony/${ceremony_id}`,axiosConfig);
};

export const getDrinksPreference = () => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.get(`${serverURL}/dashboard/getDrinkPreference/${id}`,axiosConfig);
};

// ? Stripe Paymemt

export const getPaymentHistories = () => {
  return axios.get(`${serverURL}/payment/getAllPaymentHistories`,axiosConfig);
};
export const getUserPaymentHistory = () => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.get(`${serverURL}/payment/getUserPaymentHistory/user/${id}`,axiosConfig);
};

// ? Payment Status
export const paymentStatus = () => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.get(`${serverURL}/payment/getPaymentStatus/user/${id}`,axiosConfig);
};

// ? Update Ceremony Name
export const updateCeremonyName = (data) => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.put(`${serverURL}/ceremony/user/${id}/event/${data.event_id}`, {
    ceremonies: data.ceremonies
  },axiosConfig);
};

// ? Add Drink
export const updateDrinks = (data) => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.post(`${serverURL}/drinks/user/${id}`, data,axiosConfig);
};

// ? Add Foods
export const updateFoods = (data) => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.post(`${serverURL}/foods/user/${id}`, data,axiosConfig);
};

// ? Get Selected Foods
export const selectedFoods = () => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.get(`${serverURL}/foods/user/${id}`,axiosConfig);
};

// ? Get Selected Drinks
export const selectedDrinks = () => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.get(`${serverURL}/drinks/user/${id}`,axiosConfig);
};

export const getCeremonyAttendance = () => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.get(
    `${serverURL}/dashboard/getCeremonyAttendance/user/${id}`,axiosConfig
  );
};

export const getEventsAttendance = () => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.get(`${serverURL}/dashboard/getTotalRsvpResponses/users/${id}`,axiosConfig);
};

// ? Excel upload
// {{url}}/guest/import/151
export const uploadExcel = (data) => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.post(`${serverURL}/guest/import/${id}`, data,axiosConfig);
};


export const getAllData = () => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.get(`${serverURL}/dashboard/allData/user/${id}`,axiosConfig);
};

// get('/reports/getTotalEthinicWearlist/:user_id',
export const getTotalEthinicWearlist = () => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.get(
    `${serverURL}/dashboard/reports/getTotalEthinicWearlist/${id}`,axiosConfig
  );
};

// get("/reports/getFlightListReport/:user_id
export const getFlightListReport = () => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.get(`${serverURL}/dashboard/reports/getFlightListReport/${id}`,axiosConfig);
};

// get("/reports/getFoodListReport/:user_id"
export const getFoodListReport = () => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.get(`${serverURL}/dashboard/reports/getFoodListReport/${id}`,axiosConfig);
};

// get("/reports/getMehndiList/:user_id
export const getMehndiList = () => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.get(`${serverURL}/dashboard/reports/getMehndiList/${id}`,axiosConfig);
};
export const getTotalPersonalAssistanceCombined = () => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.get(
    `${serverURL}/dashboard/reports/getTotalPersonalAssistanceCombined/${id}`,axiosConfig
  );
};
export const getTotalMUAList = () => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.get(`${serverURL}/dashboard/reports/getTotalMUAList/${id}`,axiosConfig);
};

export const getFilterFoodAndDrink = (name) => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.get(
    `${serverURL}/dashboard/reports/getResponseData/${id}/${name}`,axiosConfig
  );
};

// ? ADMIN

export const getAdminUserDetails = () => {
  return axios.get(`${serverURL}/admin/user_details`,axiosConfig);
};
export const getAdminUserQuestions = (id) => {
  return axios.get(`${serverURL}/admin/user_details/${id}/questions`, axiosConfig);
};
export const postSaveUserQuestions = (data) => {
  return axios.post(`${serverURL}/admin/user_details/questions`, data, axiosConfig);
};
export const getAdminUserReports = (id) => {
  return axios.get(`${serverURL}/admin/user_details/${id}/reports`, axiosConfig);
};
export const postSaveUserReports = (data) => {
  return axios.post(`${serverURL}/admin/user_details/${data.user_id}/reports`, data, axiosConfig);
};
export const postAddUser = (data) => {
  return axios.post(`${serverURL}/admin/user_details/add`, data, axiosConfig);
};
export const postAdminAddPackage = (data) => {
  return axios.post(`${serverURL}/admin/user_details/add_package`, data, axiosConfig);
};


// ?RSVP dynamic question

export const postQuestionSelection = (data) => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.post(`${serverURL}/user/questionSelection/${id}`, data,axiosConfig);
};

// ? GET GUEST FOR THE GIFT RECEIVED
export const getGuestForGifts = (ceremony_id) => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.get(`${serverURL}/usergift/list/${id}/${ceremony_id}`,axiosConfig);
};
export const postGiftData = (data) => {
  return axios.put(`${serverURL}/usergift`, data,axiosConfig);
};

// ?GET MARRIAGE DETAILS
export const getCouple = (user_id) => {
  if (user_id===undefined) {
    user_id = JSON.parse(localStorage.getItem("user"));
  }
  return axios.get(`${serverURL}/marriagedetails/getCouple/${user_id}`,axiosConfig);
};
export const setCouple = (data) => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.post(`${serverURL}/marriagedetails/setCouple/${id}`, data,axiosConfig);
};

export const getRSVPMarriageDetail = (rsvpCode) => {
  return axios.get(`${serverRsvpURL}/marriagedetails/${rsvpCode}`,axiosConfig);
};
export const getRSVPDynamicQuestions = (data) => {
  return axios.post(`${serverRsvpURL}/getQuestions`,data, axiosConfig);
};
export const getRSVPResponsess = (data) => {
  return axios.post(`${serverRsvpURL}/getResponses`,data, axiosConfig);
};
export const getWeddingWebsite = (rsvpCode) => {
  return axios.get(`${serverRsvpURL}/getWeddingWebsite/${rsvpCode}`,axiosConfig);
};
export const getRsvpContactDetails = (rsvpCode) => {
  return axios.get(`${serverRsvpURL}/getContactDetails/${rsvpCode}`,axiosConfig);
};
export const postRsvpContactDetails = (rsvpCode, data) => {
  return axios.post(`${serverRsvpURL}/postContactDetails/${rsvpCode}`,data, axiosConfig);
};
export const getRsvpDateContactDetails = (rsvpCode) => {
  return axios.get(`${serverRsvpURL}/getDateContactDetails/${rsvpCode}`,axiosConfig);
};
export const postRsvpDateContactDetails = (rsvpCode, data) => {
  return axios.post(`${serverRsvpURL}/postDateContactDetails/${rsvpCode}`,data, axiosConfig);
};

export const postWeddingWebsiteImage = (data) => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.post(`${serverURL}/weddingwebsite/postImage/user/${id}`,data, axiosConfig);
};
export const postWeddingWebsiteText = (data) => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.post(`${serverURL}/weddingwebsite/postText/user/${id}`,data, axiosConfig);
};
export const postWeddingContact = (data) => {
  return axios.post(`${serverRsvpURL}/weddingwebsite/postContact`,data, axiosConfig);
};
export const postDeleteWeddingWebsiteImage = (data) => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.post(`${serverURL}/weddingwebsite/deleteImage/user/${id}`,data, axiosConfig);
};



export const getDynamicRsvpQuestions = () => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.get(`${serverURL}/user/getUserQuestions/${id}`,axiosConfig);
};

export const putMarriageDetails = (data) => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.put(`${serverURL}/marriagedetails/${id}`, data,axiosConfig);
};

export const getCeremoniesForRsvp = (id) => {
  return axios.get(`${serverURL}/user/getGuestCeremony/${id}`,axiosConfig);
};

export const contactUs = (data) => {
  return axios.post(`${serverLoginURL}/contactUs`, data,axiosConfig);
};

export const getAdditionalGuestInfo = (data) => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.get(
    `${serverURL}/payment/getAdditionalGuestInfo/user/${id}`,
    data,axiosConfig
  );
};

export const getWeddingList = () => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.get(`${serverURL}/weddinglist/${id}`,axiosConfig);
};

export const cronJob = (data) => {
  return axios.post(`${serverURL}/cronjob`, data,axiosConfig);
};

export const UploadProfile = (data) => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.post(`${serverURL}/profile/upload/${id}`, data,axiosConfig);
};
export const getUploadProfile = (data) => {
  const id = JSON.parse(localStorage.getItem("user"));
  return axios.get(`${serverURL}/profile/profile-link/${id}`, data,axiosConfig);
};

export const deleteUserDetailsAdmin = (id) => {
  return axios.delete(`${serverURL}/admin/user_details/${id}`,axiosConfig);
};

export const sendSocialLoginData = (data) => {
  return axios.post(`${serverLoginURL}/dynamic-social-login`, data,axiosConfig);
};
// put("update-user/:user_id.
export const updateUserDetails = (data) => {
  return axios.put(
    `${serverURL}/user/update-user/${data.id.id}`,
    data.editedData,axiosConfig
  );
};

// ? COORDINATE API
export const setCoordinates = (data) => {
  return axios.post(`${serverURL}/coordinates/box-coordinates`, data,axiosConfig);
};

export const getCoordinates = (data) => {
  return axios.get(
    `${serverURL}/coordinates/retrieveCoordinates/${data.user_id}/${data.event_id}`,axiosConfig
  );

};
export const weddingCode = (code) => {
  return axios.get(`${serverURL}/groups/getGuestCeremonyByCode/${code}`,axiosConfig);
};
